import { render, staticRenderFns } from "./StockChargeDetails.vue?vue&type=template&id=4aad9587&scoped=true&"
import script from "./StockChargeDetails.vue?vue&type=script&lang=js&"
export * from "./StockChargeDetails.vue?vue&type=script&lang=js&"
import style0 from "./StockChargeDetails.vue?vue&type=style&index=0&id=4aad9587&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aad9587",
  null
  
)

export default component.exports